import camelCase from 'lodash/camelCase';
import snakeCase from 'lodash/snakeCase';
import config from './config.json';
import { GUILD_DOMAIN } from './utilities/envConfig';

window.services = {};

const isAcceptance = GUILD_DOMAIN?.includes('guildacceptance.com');

config.services.forEach(({ subdomain }) => {
	const envSubdomain = isAcceptance ? `${subdomain}-staging` : subdomain;
	const NAME = snakeCase(subdomain).toUpperCase().replace(/\./, '_');
	const envKey = `REACT_APP_${NAME}_URL`;
	const defaultUrl = `https://${envSubdomain}.${GUILD_DOMAIN}`;

	// ** For local testing of the mfe-catalog-tools only, run the mfe on port 8081 and uncomment the block below **
	// if (subdomain === 'mfe-catalog-tools') {
	// 	window.services[camelCase(subdomain)] = 'http://localhost:8081';
	// 	return;
	// }

	window.services[camelCase(subdomain)] = process.env[envKey] || defaultUrl;
});

// eslint-disable-next-line no-unused-expressions
import(/* webpackChunkName: "host" */ './index');
